import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogoAndLanguageSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  svg {
    width: auto;
    max-width: 178px;
    height: 32px;
  }

  @media (max-width: 480px) {
    svg {
      max-width: 158px;
      height: 29px;
    }
  }

  @media (max-width: 360px) {
    svg {
      max-width: 140px;
      height: 27px;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const StepName = styled.h6`
  font: 14px 20px;
  font-weight: 600;
  color: #0f172a;
`;

export const StepProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`;

export const ProgressText = styled.div`
  font: 14px 20px;

  font-weight: 400;
  color: #94a3b8;
`;

export const ItemsWrapper = styled.div`
  display: flex;

  margin-top: 25px;
  border-top: 1px solid #d0cfcf;
  border-bottom: 1px solid #d0cfcf;
  padding: 12px;

  @media (max-width: 480px) {
    .keepz-step-text {
      display: none !important;
    }
  }
`;
